import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
	name: 'nameFilter'
} )
export class NamePipe implements PipeTransform {

	transform( items: any[], searchText?: string, searchField?: any ): any[] {
		if ( !items ) {
			return [];
		}

		if ( !searchText ) {
			return items;
		}
		searchText = searchText.toLowerCase();
		return items.filter( it => {
			if ( searchField ) {
				return it[ searchField ].toLowerCase().includes( searchText );
			} else {
				return it.name.toLowerCase().includes( searchText );
			}
		} );
	}
}
